import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { lazy, useEffect, useState, useContext } from 'react';
import { RendererContext } from '../../../context';
var PlatformSingleValue = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@forge-ui_singlevaluechart' */
  '@atlassian/visualization/charts').then(function (module) {
    return {
      default: module.SingleValue
    };
  });
});
var Title = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@forge-ui_singlevaluechart' */
  '@atlassian/visualization/charts').then(function (module) {
    return {
      default: module.SingleValue.elements.Title
    };
  });
});
var SubTitle = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@forge-ui_singlevaluechart' */
  '@atlassian/visualization/charts').then(function (module) {
    return {
      default: module.SingleValue.elements.SubTitle
    };
  });
});

/**
 * Excluded props:
 * - children - we will not be supporting primitives/elements to compose the chart
 */

export var SingleValueChart = function SingleValueChart(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    setIsMounted = _useState2[1];
  var _ref = props.forgeDoc.props,
    data = _ref.data,
    height = _ref.height,
    width = _ref.width,
    showBorder = _ref.showBorder,
    subtitle = _ref.subtitle,
    title = _ref.title;

  // Stop viz components from being rendered in Prod Forge environment
  var _useContext = useContext(RendererContext),
    forgeEnvironment = _useContext.forgeEnvironment;
  if (forgeEnvironment === 'PRODUCTION') {
    throw new Error('EAP features are only accessible to users with EAP signup and not supported or recommended for use in production.');
  }
  return /*#__PURE__*/React.createElement(PlatformSingleValue, {
    dataValue: data,
    height: height ? height : 120,
    width: width,
    showBorder: showBorder
  }, title && /*#__PURE__*/React.createElement(Title, null, title), subtitle && /*#__PURE__*/React.createElement(SubTitle, null, subtitle), /*#__PURE__*/React.createElement(OnMount, {
    onMount: function onMount() {
      setIsMounted(true);
    }
  }));
};
var OnMount = function OnMount(_ref2) {
  var onMount = _ref2.onMount;
  useEffect(function () {
    onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};